module.exports = __webpack_public_path__ + "static/media/0.1858a7aa.svg";